export default __webpack_public_path__ + "static/media/imgAboutUs3.05658ffd.png";